import { ReactNode } from "react";

import AccountSignalHistory from "../Pages/AccountSignalHistory";
import AccountSynopsis from "../Pages/AccountSynopsis";
import AccountTeamHome from "../Pages/AccountTeamHome";
import AccountWorkspace from "../Pages/AccountWorkspace";
import AlwaysOnChannel from "../Pages/AlwaysOnChannel";
import ComingSoon from "../Pages/ComingSoon";
import CoveragePage from "../Pages/CoverageAnalysis";
import ExecutiveStaff from "../Pages/ExecutiveStaff";
import GuidancePlaybooks from "../Pages/GuidancePlaybooks";
import LeaderboardPage from "../Pages/Leaderboard";
import MyPortfolioAccounts from "../Pages/MyPortfolioAccounts";
import Relationship from "../Pages/Relationship";
import ReviewAssessments from "../Pages/ReviewAssessments";
import SponsorDrilldownPage from "../Pages/SponsorDrilldown";
import SponsorTipDetail from "../Pages/SponsorTipDetail";
import SponsorTipsLibrary from "../Pages/SponsorTipsLibrary";
import TeamSponsorFeedback from "../Pages/TeamSponsorFeedback";
import TeamViewsPage from "../Pages/TeamViews";
import TempViewsRendering from "../Pages/TempViewsRendering";
import XFactorBriefings from "../Pages/XFactorBriefings";

export interface AccountTeamRoute {
  path: string;
  element: ReactNode;
  label?: string;
}

const accountTeamRoutes: AccountTeamRoute[] = [
  {
    path: "/",
    element: <AccountTeamHome />,
    label: "Home",
  },
  {
    path: "/home",
    element: <AccountTeamHome />,
    label: "Home",
  },
  {
    path: "/always-on-channel",
    element: <AlwaysOnChannel />,
    label: "Always On Intelligence",
  },
  {
    path: "/public-data-briefings",
    element: <XFactorBriefings />,
    label: "Business Health Briefing",
  },
  {
    path: "/views-rendering",
    element: <TempViewsRendering />,
    label: "Temp Views Rendering",
  },
  {
    path: "/guidance-library",
    element: <SponsorTipsLibrary />,
    label: "Guidance Library",
  },
  {
    path: "/guidance-library/:slug",
    element: <SponsorTipDetail />,
    label: "Guidance Detail",
  },
  {
    path: "/relationship",
    element: <Relationship />,
    label: "Relationships",
  },
  {
    path: "/pending-assessments",
    element: <ReviewAssessments />,
    label: "My Assessments",
  },
  {
    path: "/team-sponsor-feedback",
    element: <TeamSponsorFeedback />,
    label: "My Check-Ins",
  },
  {
    path: "/my-portfolio-accounts",
    element: <MyPortfolioAccounts />,
    label: "My Portfolio Accounts",
  },
  {
    path: "/executive-staff",
    element: <ExecutiveStaff />,
    label: "Executive Staff",
  },
  {
    path: "/team-views",
    element: <TeamViewsPage />,
    label: "Team Views",
  },
  {
    path: "/coverage",
    element: <CoveragePage />,
    label: "Coverage",
  },
  {
    path: "/account-workspace/:id",
    element: <AccountWorkspace />,
    label: "Account Workspace",
  },
  {
    path: "/account-synopsis/:accountId",
    element: <AccountSynopsis />,
    label: "Account Synopsis",
  },
  {
    path: "/account-signal-history/:accountId",
    element: <AccountSignalHistory />,
    label: "Account Signal History",
  },
  {
    path: "/goals-milestones",
    element: <ComingSoon title="Goals & Milestones" />,
    label: "Goals & Milestones",
  },
  {
    path: "/leaderboard",
    element: <LeaderboardPage />,
    label: "Leaderboard",
  },
  {
    path: "/sponsor-drilldown",
    element: <SponsorDrilldownPage />,
    label: "Sponsor Drilldown",
  },
  {
    path: "/dashboard",
    element: <ComingSoon title="Dashboard" />,
    label: "Dashboard",
  },
  {
    path: "/guidance/playbooks",
    element: <GuidancePlaybooks />,
    label: "Playbooks Hub",
  },
];

export default accountTeamRoutes;
